<template>
    <div id="forms-page" class="breadcrumb-content">
        <SidebarChild
            :items="menuItems"
            :selected-item="type"
            :focusActive="true"
            @selected="navigateTo"
        />
        <div class="container">
            <CreateForms v-if="type === 'form'" :formId="$route.params.formId" />
            <FormList v-if="type === 'list'" />
        </div>
    </div>
</template>

<script>
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";
import { getOrUpdateFilters } from "../../../utils/persistenceStorage";
import CreateForms from "./Components/CreateForms.vue";
import FormList from "./Components/FormList.vue";

const filters = getOrUpdateFilters("forms");

export default {
    name: "Home",
    components: {
        SidebarChild,
        CreateForms,
        FormList,
    },
    data() {
        return {
            type: this.$route.query.type || filters.type || "form",
            menuItems: [
                {
                    enabled: true,
                    key: "form",
                    label: "Form Oluştur",
                    icon: {
                        type: "material-icons",
                        name: "add_circle",
                    },
                    route: { name: "form", query: { type: "form" } },
                },
                {
                    enabled: true,
                    key: "list",
                    label: "Tüm Formlar",
                    icon: {
                        type: "material-icons",
                        name: "document_scanner",
                    },
                    route: { name: "form", query: { type: "list" } },
                },
            ],
        };
    },
    methods: {
        navigateTo(item) {
            this.$router.push(item.route);
        },
    },
    watch: {
        '$route.query.type'(newType) {
            this.type = newType;
        },
        '$route.params.formId'(newFormId) {
            if (newFormId) {
                this.type = 'form';
            }
        }
    },
    created() {
        if (this.$route.params.formId) {
            this.type = 'form';
        }
    }
};
</script>

<style lang="scss" scoped>
#forms-page {
    display: flex;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;

    .container {
        padding-right: 0px !important;
        padding-left: 0px !important;
        margin: 0px !important;

        .page-content {
            padding: 20px;
        }
    }
}
</style>
